export const fileToDataURL = (input: File) => {
  if (!input) return Promise.resolve(null);

  return new Promise((resolve) => {
    const reader = new FileReader();
    reader.onloadend = () => {
      resolve(reader.result);
    };
    reader.readAsDataURL(input);
  });
};

export const fileToText = (input: File) => {
  if (!input) return Promise.resolve(null);

  return new Promise<string>((resolve) => {
    const reader = new FileReader();
    reader.onloadend = () => {
      resolve(reader.result as string);
    };
    reader.readAsText(input);
  });
};
